/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

export const SET_RENTER_QUESTIONS = '@@nzr/renterQuestions/SET_RENTER_QUESTIONS'
